import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APICONFIG } from './api.constants';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root',
})
export class EnterpriseAPIService {
  constructor(
    private config: APICONFIG,
    private http: HttpClient,
    private baseHTTP: BaseApiService
  ) {}

  post<T>(
    endpoint: string,
    body: Record<string, any> = {},
    queryParams: Record<string, any> = {},
    ignoreProduct: boolean = false
  ) {
    const url = this.baseHTTP.cleanUrl(this.config.enterpriseURL, endpoint);

    const params = {
      ...queryParams,
    };

    if (ignoreProduct === false) {
      body.productType = this.baseHTTP.getProductType();
      params.productType = this.baseHTTP.getProductType();
    }

    return this.http.post<T>(url, body, {
      headers: this.baseHTTP.createAuthorizationHeader(),
      params,
    });
  }

  login<T>(
    endpoint: string,
    body: Record<string, any> = {},
    queryParams: Record<string, any> = {}
  ) {
    const url = this.baseHTTP.cleanUrl(this.config.enterpriseURL, endpoint);
    return this.http.post<T>(url, body, {
      params: {
        ...queryParams,
        productType: this.baseHTTP.getProductType(),
      },
    });
  }

  put<T>(
    endpoint: string,
    body: Record<string, any> = {},
    queryParams: Record<string, any> = {},
    ignoreProduct: boolean = false
  ) {
    const url = this.baseHTTP.cleanUrl(this.config.enterpriseURL, endpoint);

    const params = {
      ...queryParams,
    };

    if (ignoreProduct === false) {
      body.productType = this.baseHTTP.getProductType();
      params.productType = this.baseHTTP.getProductType();
    }

    return this.http.put<T>(url, body, {
      headers: this.baseHTTP.createAuthorizationHeader(),
      params,
    });
  }

  patch<T>(
    endpoint: string,
    data: Record<string, any> = {},
    params: Record<string, any> = {}
  ) {
    const url = this.baseHTTP.cleanUrl(this.config.enterpriseURL, endpoint);
    return this.http.patch<T>(url, data, {
      headers: this.baseHTTP.createAuthorizationHeader(),
      params: {
        ...params,
        productType: this.baseHTTP.getProductType(),
      },
    });
  }

  get<T>(endpoint: string, params: Record<string, any> = {}) {
    const url = this.baseHTTP.cleanUrl(this.config.enterpriseURL, endpoint);

    return this.http.get<T>(url, {
      headers: this.baseHTTP.createAuthorizationHeader(),
      params: {
        ...params,
        productType: this.baseHTTP.getProductType(),
      },
    });
  }

  delete<T>(
    endpoint: string,
    body: Record<string, any> = {},
    params: Record<string, any> = {}
  ) {
    const url = this.baseHTTP.cleanUrl(this.config.enterpriseURL, endpoint);
    return this.http.delete<T>(url, {
      headers: this.baseHTTP.createAuthorizationHeader(),
      params: {
        ...params,
        productType: this.baseHTTP.getProductType(),
      },
      body: body || {},
    } as any) as any;
  }
}
